import type TauriDatabase from "@tauri-apps/plugin-sql";
import { type Database as BunDatabase } from "bun:sqlite";

import { type SqliteTableDef } from "../schema";
import { runCreateTable } from "./runCreateTable";

/**
 * Creates a table in the database if it doesn't already exist.
 * This is a convenience wrapper around runCreateTable that always sets ifNotExists to true.
 * @param db The database connection (either Bun's SQLite or Tauri's SQL plugin)
 * @param tableDef The table definition to create
 */
export async function runCreateTableIfNotExists(
	db: BunDatabase | TauriDatabase,
	tableDef: SqliteTableDef
): Promise<void> {
	await runCreateTable(db, tableDef, true);
}
